import React from "react";
import Checkbox from "./Checkbox";
import purifyHTML from "../../../utils/purifyHTML";

export default class CheckboxPlus extends Checkbox {
  handleChange = (e) => {
    this.props.formikForm.setFieldValue(
      this.props.config.name,
      e.target.checked
    );
    this.props.formikField.onBlur(e); //validate directly for errors
  };
  renderField() {
    const {
      formikField,
      isRequired,
      config: { name, labelCollapsed, labelExpanded, readOnly, disabled, show },
    } = this.props;
    const listeners = {};
    if (readOnly) {
      listeners.onClick = (e) => {
        e.preventDefault();
      };
    }
    return (
      <div
        className={`field__group ${
          show !== null && show === "False" ? "field_hidden" : ""
        }`}
      >
        <div className="field__option--checkbox">
          <input
            className="field__checkbox"
            type="checkbox"
            id={name}
            checked={formikField.value}
            aria-required={!!isRequired}
            disabled={!!disabled}
            {...formikField}
            onChange={this.handleChange}
            {...listeners}
          />
          <label
            htmlFor={name}
            className="field__option-label-checkbox-plus"
            dangerouslySetInnerHTML={purifyHTML(
              formikField.value ? labelExpanded : labelCollapsed
            )}
            {...listeners}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/CheckboxPlus.js